import styled from 'styled-components'

export const Row = styled.li`
  padding: ${({ theme }) =>
    `${theme.functions.getSpace()} ${theme.functions.getSpace()} ${theme.functions.getSpace()} 0`};
`
